/**
 * Frontend permission constants.
 * MODULE_KEYS must match the moduleName values stored in the DB Modules collection
 * (and used in the backend constants/permissions.js).
 */

export const MODULE_KEYS = {
  USER:                'user',
  ROLE:                'role',
  PROJECT:             'project',
  CLIENT:              'client',
  DEPARTMENT:          'department',
  ASSIGNMENT:          'assignment',
  RESOURCE_ALLOCATION: 'resource-allocation',
  LOG:                 'log',
};

export const ACTIONS = {
  VIEW:   'view',
  ADD:    'add',
  UPDATE: 'update',
  DELETE: 'delete',
};

/**
 * Maps each frontend route URL segment to its required permission.
 * Used by PermissionRoute to guard pages.
 */
export const ROUTE_PERMISSIONS = {
  'mgmt-user-add':            { module: MODULE_KEYS.USER,   action: ACTIONS.ADD    },
  'mgmt-user-list':           { module: MODULE_KEYS.USER,   action: ACTIONS.VIEW   },
  'user-add':                 { module: MODULE_KEYS.USER,   action: ACTIONS.ADD    },
  'user-list':                { module: MODULE_KEYS.USER,   action: ACTIONS.VIEW   },
  'user-edit/:id':            { module: MODULE_KEYS.USER,   action: ACTIONS.UPDATE },
  'role-add':                 { module: MODULE_KEYS.ROLE,   action: ACTIONS.ADD    },
  'role-list':                { module: MODULE_KEYS.ROLE,   action: ACTIONS.VIEW   },
  'permissions-assign':       { module: MODULE_KEYS.ROLE,   action: ACTIONS.UPDATE },
  'permissions-manage':       { module: MODULE_KEYS.ROLE,   action: ACTIONS.VIEW   },
  'project-add':              { module: MODULE_KEYS.PROJECT, action: ACTIONS.ADD   },
  'project-list':             { module: MODULE_KEYS.PROJECT, action: ACTIONS.VIEW  },
  'client-add':               { module: MODULE_KEYS.CLIENT,  action: ACTIONS.ADD   },
  'client-list':              { module: MODULE_KEYS.CLIENT,  action: ACTIONS.VIEW  },
  'department-add':           { module: MODULE_KEYS.DEPARTMENT, action: ACTIONS.ADD    },
  'department-list':          { module: MODULE_KEYS.DEPARTMENT, action: ACTIONS.VIEW   },
  'resource-allocation-add':  { module: MODULE_KEYS.RESOURCE_ALLOCATION, action: ACTIONS.ADD  },
  'resource-allocation-list': { module: MODULE_KEYS.RESOURCE_ALLOCATION, action: ACTIONS.VIEW },
  'resource-allocation':      { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
  'client-view':              { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
  'project-view':             { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
  'hod-view':                 { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
  'resource-view':            { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
  'employee-view':            { module: MODULE_KEYS.ASSIGNMENT, action: ACTIONS.VIEW },
};